import type { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CONFIG } from '@config';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

const oktaDomain = ((): string => {
  try {
    return CONFIG.auth.oktaTokenUrl ? new URL(CONFIG.auth.oktaTokenUrl).hostname : '';
  } catch {
    return '';
  }
})();

const isOktaRequest = (url: string): boolean =>
  url.startsWith('/okta') || (oktaDomain !== '' && url.includes(oktaDomain));

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const authService = inject(AuthService);

  if (isOktaRequest(req.url)) {
    return next(req);
  }

  const token = tokenService.getToken();
  const authReq = token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        tokenService.clearToken();
        authService.initiateLogin().catch(console.error);
      }

      return throwError(() => error);
    }),
  );
};
